export default "images/风险物体提示.png";